const DEFAULT_DATE_FORMAT = 'MM.DD.YYYY';
const ADMIN_ROLE = 'Admin';
export { DEFAULT_DATE_FORMAT, ADMIN_ROLE };
